<!-- <template>
  <div :class="inlinerows == 'true' ? 'mb-3 row' : blockClasses">
    <label v-if="label" for="exampleFormControlInput1" :class="inlinerows == 'true' ? inlineLabelClass + ' col-form-label' : 'form-label'">{{ label }}</label>
    <div :class="inlinerows == 'true' ? inlineSelectClass : label ? '' : blockLabelClass">
    -->

<template>
  <input-holder :inlinerows="inlinerows" :inlinerowclasses="inlinerowclasses" :label="label" :inlineLabelClass="inlineLabelClass" :inlineInputClass="inlineSelectClass" error="">
    <select class="custom-select" v-model="selectedrow" :id="id" :name="name" :required="mandatory ? true : false" :placeholder="placeholder" :class="classes" @change="onInput">
      <option selected v-if="placeholder" value="0">{{ placeholder }}</option>

      <option v-for="(dat, i) in data" :key="i" :value="dat[valuefield]">
        {{ $t(dat[textfield]) }}
      </option>
    </select>
    <small class="input-error" v-if="error">{{ error }}</small>
  </input-holder>
</template>

<script>
import "../../assets/scss/form-group.scss";
import "../../assets/scss/selector.scss";
import InputHolder from "./InputHolder.vue";

export default {
  name: "selector",
  data() {
    return {
      selectedrow: 0,
    };
  },
  created() {
    if (this.$props.selected != "") {
      this.selectedrow = this.$props.selected;
    }
  },
  props: {
    label: {
      type: String,
      required: false,
    },
    inlinerows: {
      // type: Boolean,
      default: false,
    },
    inlinerowclasses: {
      default: "mb-3",
    },
        inlineLabelClass: {
      default: "col-sm-2",
    },
    inlineSelectClass: {
      default: "col-sm-2",
    },
    inlineInputClass: {
      default: "col-sm-10",
    },
    error: {
      type: String,
      default: "",
    },

    // inlinerows: {
    //   // type: Boolean,
    //   default: false,
    // },
    // blockClasses: {
    //   type: String,
    //   default: "mb-3",
    // },
    // label: {
    //   type: String,
    //   required: false,
    // },

    // inlineSelectClass: {
    //   default: "col-sm-10",
    // },
    // blockLabelClass: {
    //   type: String,
    //   default: "col-md-12",
    // },
    // error: {
    //   type: String,
    //   default: "",
    // },

    /*
** receive produt price based on product id and user id. Either the product or user is not available, should return response indicating these
	- product_price
	- discount ( if available )
	- quantity
** API endpoint to submit payment details. The payload will include 
	- user_id  ( buyer )
	- payment_id
	- order 
		- unit_price
		- quantity
		- product_id
		- total
	- participants ( multiple/single )
		- first_name
		- last_name
		- email
		- phone
		- extra_field
	- sucess_url
	- fail_url
	- callback_api
** on success call back from the API endpoint we need to receive 
	- payment_id ( the exact payment_id we post on payment payload)
	- purchase_id
	- status
	- response_message
** on failure call back from the API endpoint we need to receive
	- response_message
*/

    id: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },

    classes: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      required: false,
    },
    mandatory: {
      // type: Boolean,
      default: false,
    },
    data: {
      //type: Object,
      required: true,
    },
    valuefield: {
      type: String,
      required: true,
      default: "id",
    },
    textfield: {
      type: String,
      required: true,
      default: "name",
    },
    selected: {
      default: "",
    },
  },

  methods: {
    onInput() {
      this.$emit("input", this.selectedrow);
      this.$emit("change");
    },
  },

  computed: {
    optionsList() {
      return this.$props.data;
    },
  },
  components: {
    InputHolder,
  },
};
</script>
